import { CoverageBlockInput, findCoverageConflicts } from './coverageHoursOverlap';

export type CoverageHoursConflictViewModel = {
  hasConflict: boolean;
};

type Args = {
  blocks: CoverageBlockInput[];
  blockId: string;
};

export function createCoverageHoursConflictViewModel({
  blocks,
  blockId,
}: Args): CoverageHoursConflictViewModel {
  // The rule pairs each block only with the ones after it, so otherBlockId is always the
  // later side: the block that landed on what was already there, and the only one to blame.
  const introducedTheOverlap = findCoverageConflicts(blocks).some(
    conflict => conflict.otherBlockId === blockId
  );

  return { hasConflict: introducedTheOverlap };
}
